import {useMutation, useQuery} from 'react-query';

import useFetch from '~api/useFetch';
import {ApiEndpoints} from '~constants/api';
import {
    PlotsPremiumPostData,
    PlotsPremiumPostResponse,
    PlotsPremiumResponse,
} from '~types/Plots';

export function useFetchPlotsPremium() {
    const {apiGet} = useFetch();

    return useQuery<PlotsPremiumResponse>([ApiEndpoints.PlotsPremium], () =>
        apiGet(ApiEndpoints.PlotsPremium, {}),
    );
}

export function usePostPlotsPremium(ids: number[]) {
    const {apiPost} = useFetch();

    return useMutation<PlotsPremiumPostResponse, {}, PlotsPremiumPostData>(
        [ApiEndpoints.PlotsPremium, ids],
        (data) =>
            apiPost(ApiEndpoints.PlotsPremium, {
                data,
            }),
    );
}
